import { useQuery } from 'react-query';

import api from '@root/api';

export default function useCurrentJob(queryOptions = {}) {
  return useQuery(['currentBulkGenerationJob', {}], () => api.bulkGeneration.getCurrentJob(), queryOptions);
}
